var round = function (value, decimalPlaces) {
    if (value && decimalPlaces)
        return Number(Math.round(parseFloat(value + "e" + decimalPlaces)) + "e-" + decimalPlaces).toFixed(decimalPlaces);
    else
        return undefined;
};
var CommaSeperatedNums = function (num) {
    return Number(num).toLocaleString("en", {
        minimumFractionDigits: 0,
    });
};
function generateRandom() {
    // Generate a secure random 32-bit unsigned integer
    var randomBuffer = new Uint32Array(1);
    window.crypto.getRandomValues(randomBuffer);
    // Convert the random integer to a floating-point number between 0 (inclusive) and 1 (exclusive)
    return randomBuffer[0] / (0xffffffff + 1);
}
var isNumber = function (value) {
    return !isNaN(value) && !isNaN(parseFloat(value));
};
function toFixedTrunc(x, digits) {
    if (digits === void 0) { digits = 2; }
    if (x === "-")
        return x;
    var factor = Math.pow(10, digits);
    return (Math.trunc(x * factor) / factor).toFixed(digits);
}
/**
 *
 * @param {number} num
 * @description Converts a number to a more readable format (K, M, B)
 * @example
 * scaleNumber(1500) // "1.50K"
 * scaleNumber(1500000) // "1.50M"
 * scaleNumber(1500000000) // "1.50B"
 * scaleNumber(150) // "150"
 * scaleNumber(0) // "0"
 * scaleNumber(-1500) // "-1.50K"
 * scaleNumber(-150) // "-150"
 * scaleNumber(-0) // "0"
 * scaleNumber(-0.0001) // "-0.00"
 * @returns
 */
function scaleNumber(num) {
    if (num >= 1000000000) {
        return toFixedTrunc(num / 1000000000) + " B"; // Billions
    }
    else if (num >= 1000000) {
        return toFixedTrunc(num / 1000000) + " M"; // Millions
    }
    else if (num >= 1000) {
        return toFixedTrunc(num / 1000) + " K"; // Thousands
    }
    else {
        var valueStr = toFixedTrunc(Number(num), 2); // No conversion for smaller numbers
        console.log("[INFO] No conversion happened for the Amount ".concat(num, " => ").concat(valueStr));
        return valueStr;
    }
}
var safeNumber = function (value) {
    var num = Number(value);
    return isNaN(num) ? 0 : num;
};
export { round, CommaSeperatedNums, scaleNumber, isNumber, toFixedTrunc, generateRandom, safeNumber, };
